import { classes } from 'html-classes';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { LimitReachedTooltipProps } from './interfaces';
import styles from './LimitReachedTooltip.module.scss';
import { useLimitReachedTooltip } from './useLimitReachedTooltip';

const LimitReachedTooltip: React.FC<LimitReachedTooltipProps> = ({
  isLimitReached,
  className,
  children,
  anchor,
  onClose: onCloseProp,
  style,
}) => {
  const rootRef = useRef<Nullable<HTMLDivElement>>(null);
  const { t } = useTranslation();
  const { isOpen, onClose } = useLimitReachedTooltip(isLimitReached);

  const handleClose = () => {
    onCloseProp ? onCloseProp() : onClose();
  };

  useEffect(() => {
    const listener = (e: Event) => {
      if (!isOpen || !anchor || !rootRef.current) {
        return;
      }

      const targetElement = e.target as HTMLElement;
      if (
        rootRef.current.contains(targetElement) ||
        anchor.contains(targetElement)
      ) {
        return;
      }

      handleClose();
    };

    document.addEventListener('click', listener);
    return () => {
      document.removeEventListener('click', listener);
    };
  }, [isOpen, anchor, onCloseProp]);

  if (!anchor && !isOpen) {
    return null;
  }

  return (
    <div
      className={classes([styles.tooltip, className])}
      style={style}
      ref={rootRef}
    >
      <span className={styles.content}>{children || t('noMoreInStock')}</span>
      <span
        role="button"
        tabIndex={-1}
        className={styles.okBtn}
        onClick={handleClose}
      >
        {t('ok')}
      </span>
    </div>
  );
};

export default LimitReachedTooltip;
